import { DownloadFileResponse, GetVodResponse, GetVodResponseError } from '@/server/services/types'
import axios, { AxiosProgressEvent } from 'axios'

// 🥷🏼 Here we are using proxy to fetch api from BlendVision
// 🥷🏼 for hidden the secret key of BlendVision
export const getVod = async (id: string): Promise<GetVodResponse | GetVodResponseError> =>
  fetch(`/api/proxy/vod/${id}`)
    .then((res) => res.json())
    .then((data) => data.data)

export const getFile = async (id: string): Promise<DownloadFileResponse> =>
  fetch(`/api/proxy/file/${id}`)
    .then((res) => res.json())
    .then((data) => data.data)

// 🧬 onUploadProgress is only usable in frontend
export const uploadParts = async ({
  presignedUrl,
  chunk,
  partNumber,
  onProgress,
}: {
  presignedUrl: string
  chunk: Blob
  partNumber: number
  onProgress?: (progress: AxiosProgressEvent) => void
}) => {
  // 🧬 we use axios here for onUploadProgress already implemented
  const response = await axios.put(presignedUrl, chunk, {
    headers: {
      // Setting necessary headers for the upload request.
      'Content-Type': 'application/octet-stream',
    },
    onUploadProgress: onProgress,
  })

  return {
    etag: response.headers.etag ?? '',
    part_number: partNumber,
  }
}
